import React from 'react';
import classnames from 'classnames';

import {Label} from '../Label';

import * as styles from './Select.module.css';

export function Select({
  children,
  label,
  size = 'medium',
  errorMessage,
  ...props
}) {
  const selectClasses = classnames(
    styles.Select,
    styles[`Select-Size-${size}`],
    errorMessage != null && styles.Error,
  );

  return (
    <div>
      {label ? <Label>{label}</Label> : null}

      <div className={styles.Container}>
        <select className={selectClasses} {...props}>
          {children}
        </select>
      </div>

      <p className={styles.ErrorMessage}>{errorMessage}</p>
    </div>
  );
}
